const footerContent = {
  WHATSAPP_URL: 'https://api.whatsapp.com/send?phone={moonsNum}',
  facebook: 'https://www.facebook.com/welovemoons[domain]',
  instagram: 'https://www.instagram.com/welovemoons[domain]',
  youtube: 'https://www.youtube.com/welovemoons'
}

export default footerContent
